import React from 'react';
import { Modal } from '@gerdau/hefesto';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
import { purchaseOrigin } from '../../../services/MVP/utils';

interface ExpiredOrderProps {
  onBackClick: () => void;
  onStartClick: () => void;
}

const ExpiredOrderModal: React.FC<ExpiredOrderProps> = ({
  onBackClick,
  onStartClick
}) => {
  const tipo_compra = purchaseOrigin();
  const dispatch = useDispatch();

  const handleClickTagging = (labelButton: string) => {
    dispatch(
      sendTagging({
        event: 'pedido_expirado',
        screenName: 'checkout',
        tipo_compra: tipo_compra,
        botao_navegacao: labelButton
      })
    );
  };
  const onBackClickLocal = () => {
    onBackClick();
    handleClickTagging('Voltar ao início');
  };
  const onStartClickLocal = () => {
    onStartClick();
    handleClickTagging('Iniciar novo pedido');
  };
  return (
    <Modal
      buttons={{
        left: {
          children: 'Voltar ao início',
          name: 'back-to-start',
          onClick: onBackClickLocal,
          type: 'button',
          variant: 'secondary'
        },
        right: {
          children: 'Iniciar novo pedido',
          name: 'start-new-order',
          onClick: onStartClickLocal,
          type: 'button',
          variant: 'primary'
        }
      }}
      modalSize="sm"
      title="Seu pedido expirou"
    >
      <span>Deseja iniciar um novo pedido?</span>
    </Modal>
  );
};

export default ExpiredOrderModal;
